<template>
  <div>
    <div class="my-commodity">
      <div class="commodity-title">我的商品</div>
      <el-button class="add-commodity" @click="addCommodity()">
        <svg class="icon icona_xiadan_addshangpin" aria-hidden="true">
          <use xlink:href="#icona_xiadan_addshangpin" />
        </svg>
        添加商品
      </el-button>
    </div>
    <div class="commodity-th">
      <div class="commodity-img">图片</div>
      <div class="commodity-name">商品名称</div>
      <div class="commodity-type">商品类别</div>
      <div class="commodity-describe">商品描述</div>
      <div class="commodity-operate">操作</div>
    </div>
    <div class="commodity-trs">
      <div class="null-data" v-if="goodsList.total <= 0">
        <img src="../../assets/img/pic_none.png" alt />
        <div class="null-text">暂无商品 快去添加商品吧</div>
      </div>
      <div
        class="commodity-tr"
        v-for="(item, index) in goodsList.rows"
        :key="index"
      >
        <div class="commodity-img" @click="openDetail(item)">
          <img :src="item.imgUrl" alt />
        </div>
        <div class="commodity-name" @click="openDetail(item)">
          {{ item.name }}
        </div>
        <div class="commodity-type">{{ item.goodsTypeName }}</div>
        <div class="commodity-describe">{{ item.description }}</div>
        <div class="commodity-operate">
          <svg
            class="icon iconq_bianji"
            @click="addCommodity(item)"
            aria-hidden="true"
          >
            <use xlink:href="#iconq_bianji" />
          </svg>
          <svg
            class="icon iconq_chakan"
            @click="openDetail(item)"
            aria-hidden="true"
          >
            <use xlink:href="#iconq_chakan" />
          </svg>
          <svg
            class="icon iconq_delete"
            @click="deleteCommodity(item)"
            aria-hidden="true"
          >
            <use xlink:href="#iconq_delete" />
          </svg>
        </div>
      </div>
    </div>
    <el-pagination
      v-if="goodsList.total > 12"
      class="fenye commodity-fenye"
      background
      layout="prev, pager, next"
      :total="goodsList.total"
      :page-size="12"
      @current-change="pageSize"
    ></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      goodsList: {
        rows: [],
        total: 1
      }
    };
  },
  mounted() {
    if (Cookies.get("token") != undefined) {
      this.getGoods();
    }
  },

  methods: {
    pageSize(val) {
      this.page = val;
      this.getGoods();
    },
    // 获取商品
    getGoods() {
      var _this = this;
      this.$post(`/user/api/goods/list?pageIndex=${this.page}&pageNum=12`).then(
        res => {
          if (res.code == 0) {
            _this.goodsList = res.data;
          } else {
            this.$message(res.message);
          }
        }
      );
    },
    // 添加商品
    addCommodity(item) {
      if (item != null) {
        this.$router.push({
          path: "/user/commodity/adding",
          query: { id: item.id }
        });
      } else {
        this.$router.push({ path: "/user/commodity/adding" });
      }
    },
    // 商品详情
    openDetail(item) {
      this.$router.push({
        path: "/user/commodity/detail",
        query: { id: item.id }
      });
    },
    // 删除商品
    deleteCommodity(item) {
      var _this = this;
      this.$confirm("确认删除商品？删除后将无法恢复", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$post(`/user/api/goods/del?id=${item.id}`).then(res => {
            if (res.code == 0) {
              _this.goodsList.rows.remove(item);
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            } else {
              this.$message(res.message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>
<style lang="scss">
.null-data {
  height: 204px;
  padding-top: 53px;
  img {
    width: 375px;
    height: 94px;
    margin: 0 auto;
    display: block;
  }
  .null-text {
    color: #b4b7bc;
    font-size: 14px;
    text-align: center;
    margin-top: 8px;
  }
}
</style>
<style lang="scss" scoped>
.my-commodity {
  background: #ffffff;
  padding: 24px 20px 24px 20px;
  .commodity-title {
    color: #5e6066;
    font-size: 18px;
    height: 18px;
    line-height: 1;
  }
  .add-commodity {
    width: 78px;
    height: 24px;
    background: rgba(52, 85, 211, 1);
    border-radius: 2px;
    border: 1px solid rgba(52, 85, 211, 1);
    color: #ffffff;
    font-size: 12px;
    padding: 0;
    margin-top: 34px;
  }
}
.commodity-img {
  width: 124px;
  cursor: pointer;
  img {
    width: 70px;
    height: 70px;
  }
}
.commodity-name {
  width: 200px;
  cursor: pointer;
}
.commodity-type {
  width: 140px;
}
.commodity-describe {
  width: 250px;
}
.commodity-operate {
  width: 184px;
  .icon {
    width: 32px;
    height: 32px;
    margin-right: 8px;
    color: #b4b7bc;
    cursor: pointer;
  }
  .icon:last-child {
    margin-right: 0;
  }
  .iconq_chakan:hover,
  .iconq_bianji:hover {
    color: #3455d3;
  }
  .iconq_delete:hover {
    color: #f75658;
  }
}
.commodity-th {
  display: flex;
  height: 36px;
  background: #f9fafa;
  & > div {
    display: flex;
    justify-content: center;
    align-items: center;
    color: #5e6066;
    font-size: 12px;
  }
}
.commodity-trs {
  background: #ffffff;
  // padding-bottom: 20px;
  // padding-top: 24px;
  padding: 24px 20px 20px 20px;
  .commodity-tr {
    display: flex;
    height: 70px;
    background: #ffffff;
    margin-top: 10px;
    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #2f3133;
      font-size: 12px;
      line-height: 22px;
      height: 70px;
      overflow: hidden;
    }
    &:nth-child(2n) {
      background: #f9fafa;
    }
  }
  .commodity-tr:nth-child(1) {
    margin-top: 0;
  }
}
.commodity-fenye {
  margin-top: 0;
  background: #ffffff;
  padding-bottom: 20px;
  padding-right: 20px;
}
</style>
